import * as React from "react";
import { Models, Assets, Components, Services } from "@sendum/core";

import s from "./VisibilityRules.module.scss";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setError, setMultiplePlaceComponent, setRules as updateRulesInRedux } from "../store/VisibilityActions";
import { VisibilityRootState } from "../store/VisibilityStore";
import { AnyAction } from "redux";
// import {WidgetAPI} from "../../../services/WidgetAPI";

const cloneDeep = require("lodash/cloneDeep");

const VisibilityRules = () => {
	const dispatch = useDispatch();
	const initialRules = useSelector((state: VisibilityRootState) => state.Visibility.rules);
	const shipment = useSelector((state: VisibilityRootState) => state.Visibility.shipment, shallowEqual);
	const device = useSelector((state: VisibilityRootState) => state.Visibility.device, shallowEqual);
	const rulesLoading = useSelector((state: VisibilityRootState) => state.Visibility.rulesLoading);
	const present = useSelector((state: VisibilityRootState) => state.Visibility.present, shallowEqual);

	const [rules, setRules] = React.useState(new Array<Models.Rule>());
	const [isSaveButtonVisible, setIsSaveButtonVisible] = React.useState<boolean>(false);
	const [saving, setSaving] = React.useState(false);

	React.useEffect(() => {
		if (initialRules) {
			const displayRules = initialRules.rules.filter(rule => !(device?.isContainer() && rule.config?.hideForContainer));
			setRules(cloneDeep(displayRules));
		}
	}, [initialRules]);

	React.useEffect(() => {
		let isVisible = false;
		initialRules?.rules.forEach(rule => {
			const cRule = rules.find(r => r.type === rule.type);
			if (!!cRule && typeof cRule.value === "number" && cRule.value !== rule.value) {
				isVisible = true;
			} else if (!!cRule && (cRule.value[0] !== rule.value[0] || cRule.value[1] !== rule.value[1])) {
				isVisible = true;
			}
		});
		setIsSaveButtonVisible(isVisible);
	}, [rules]);

	const onClickCloseHandler = (event: any) => {
		!!event.preventDefault && event.preventDefault();
		dispatch(setMultiplePlaceComponent("graph") as unknown as AnyAction);
		if (initialRules) {
			const displayRules = initialRules.rules.filter(rule => !(device?.isContainer() && rule.config?.hideForContainer));
			setRules(cloneDeep(displayRules));
		}
	};

	const onClickSaveHandler = (event: any) => {
		event.preventDefault && event.preventDefault();

		if (!shipment?.id || !device?.id) {
			return;
		}
		setSaving(true);
		const rulesToPut = cloneDeep(initialRules);
		rulesToPut.rules = rules;

		Services.API.WidgetsApi.putRules(shipment.id, device.id, rulesToPut?.dbFormat())
			.then(() => {
				setSaving(false);
				dispatch(updateRulesInRedux(rulesToPut) as unknown as AnyAction);
			})
			.catch((err: any) => {
				console.error(err);
				setSaving(false);
				dispatch(setError(err) as unknown as AnyAction);
			});
	};

	const ruleOnChangeHandler = (rule: Models.Rule) => {
		const tRules = [...rules];
		const index = tRules.findIndex((r: Models.Rule) => r.type === rule.type);
		if (index !== -1) {
			tRules[index] = rule;
			const setTempRule = tRules.find((r: Models.Rule) => r.type === "setTemp");
			const internalTempRule = tRules.find((r: Models.Rule) => r.type === "InternalTemp");
			if (rule.type === "setTemp" && internalTempRule && setTempRule) {
				if (internalTempRule.value[0] >= setTempRule.value) {
					internalTempRule.value[0] = setTempRule.value === setTempRule.config?.minValue ? setTempRule.config?.minValue : setTempRule.value;
				}
				if (internalTempRule.value[1] <= setTempRule.value) {
					internalTempRule.value[1] = setTempRule.value === setTempRule.config?.maxValue ? setTempRule.config?.maxValue : setTempRule.value;
				}
				const internalTempRuleIndex = tRules.findIndex((r: Models.Rule) => r.type === "InternalTemp");
				tRules[internalTempRuleIndex] = internalTempRule;
			}
			if (rule.type === "InternalTemp" && internalTempRule && setTempRule) {
				if (internalTempRule.value[0] >= setTempRule.value) {
					setTempRule.value = internalTempRule.value[0].value === setTempRule.config?.minValue ? setTempRule.config?.minValue : internalTempRule.value[0];
				}
				if (internalTempRule.value[1] <= setTempRule.value) {
					setTempRule.value = internalTempRule.value[1] === setTempRule.config?.maxValue ? setTempRule.config?.maxValue : internalTempRule.value[1];
				}
				const setTempRuleIndex = tRules.findIndex((r: Models.Rule) => r.type === "setTemp");
				tRules[setTempRuleIndex] = setTempRule;
			}
			setRules(tRules);
		}
	};

	const isLoading = (): boolean => !!rulesLoading.get(`${device?.id}#${device?.shipment.id}`);

	return (
		<div className={s.rules}>
			<Components.LoadingComponent loading={saving} text={"Saving..."}/>
			<Components.LoadingComponent loading={isLoading()} text={"Loading..."}/>
			{(!saving && !isLoading()) && (
				<>
					<div className={s.close}>
						<img alt={"close"} src={Assets.Close} onClick={onClickCloseHandler}/>
					</div>
					<div className={s.rules__column}>
						<div className={[s.rules__header, s.header].join(" ")}>
							<div className={s.header__row}>
								<div className={s.header__text}>
                  RULES
								</div>
							</div>
						</div>
						{rules.map((rule: Models.Rule) => (<Components.Rule key={rule.type} rule={rule} onChange={ruleOnChangeHandler}/>))}
						{present && present.status?.value === "Released" && (<div className={[s.rules__footer, s.footer].join(" ")}>
							<div className={s.footer__row}>
								{isSaveButtonVisible && (<button onClick={onClickSaveHandler}>Save</button>)}
								<button onClick={onClickCloseHandler}>Exit</button>
							</div>
						</div>)}
					</div>
				</>
			)}
		</div>
	);
};

export default VisibilityRules;
